import { Container } from 'react-bootstrap'
import '../styles/pages.scss'



let FAQ = () => {
    return (
        <Container>
            <div className="faq">
                <h4>How long will it take to shipping ?</h4>
                <p>Mostly take between 5 to 7 days to shipping</p>
                <br />
                <h4>How will it cost for Shipping ?</h4>
                <p>Shipping cost : $10</p>
                <br />
                <h4>Are  the brands original ?</h4>
                <p>Yes are original and we care to provide best quality</p>
            </div>
        </Container>

    )
}

export default FAQ